import { Injectable, signal, WritableSignal } from '@angular/core';
import { SubStepEnum } from '../models/sub-step.enum';

@Injectable()
export class MaterialSubStepService {
  subStep: WritableSignal<SubStepEnum> = signal(SubStepEnum.Installations);

  /**
   * Gère l'affichage/masquage des sous-menus en accordéon
   * @param step - Numéro du sous-menu (1: Poses, 2: Lames, 3: Poteaux, 4: Lames décoratives, 5: Décors, 6: Panneaux, 7: Portillons)
   */
  toggleCollapse(step: SubStepEnum): void {
    if (this.subStep() !== step) {
      this.subStep.set(step);
    } else {
      this.subStep.set(SubStepEnum.None);
    }
  }
}
